/* template */
<template minapp="mpx" xlang="wxml"><div class="mpx-root-view"><mpx-view @tap="click" :class="({'entrance-margin': needMargin})" class="entrance"><div class="title"><mpx-image :src="(trainIconUrl)" class="train"></mpx-image>{{ title }}</div><div class="button">{{ button }}<mpx-image :src="(arrowIconUrl)" class="arrow"></mpx-image></div></mpx-view><es-riskmanagement :tickets12306="(!needLogin12306)"/></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m921da7b8"}'>
  .entrance
    display flex
    background #FFFFFF
    border-radius 8px
    margin 15px 0 2.5px 0px
    padding 10px 14px
    align-items center
    justify-content space-between
    font-family PingFang SC
    &-margin
      margin 15px 10px 0 10px
    .title
      display flex
      align-items center
      color #333333
      font-weight 600
      font-size 16px
    .train
      width 16px
      height 18px
      margin-right 5px
    .button
      color #999999
      font-size 14px
      display flex
      align-items center
    .arrow
      width 4.5px
      height 8px
      margin-left 4.5px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m921da7b8"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./tickets12306-entrance.mpx.js?isComponent&outputPath=components%2Ftickets12306-entrance921da7b8%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./tickets12306-entrance.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Ftickets12306-entrance921da7b8%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m921da7b8"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/tickets12306-entrance921da7b8/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-riskmanagement':getComponent(require("../../login12306/components/rm/risk-management.mpx?isComponent&outputPath=components%2Frisk-management0659070a%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
